export interface IUpdatedBy {
  id: number;
  name?: string;
}
